export const types = {
    QUOTE_REQUEST: "currencyExchange/QUOTE_REQUEST",
    QUOTE_SUCCESS: "currencyExchange/QUOTE_SUCCESS",
    QUOTE_FAILURE: "currencyExchange/QUOTE_FAILURE",
    HISTORY_REQUEST: "currencyExchange/HISTORY_REQUEST",
    HISTORY_SUCCESS: "currencyExchange/HISTORY_SUCCESS",
    HISTORY_FAILURE: "currencyExchange/HISTORY_FAILURE",
    PREVIEW_REQUEST: "currencyExchange/PREVIEW_REQUEST",
    PREVIEW_SUCCESS: "currencyExchange/PREVIEW_SUCCESS",
    PREVIEW_FAILURE: "currencyExchange/PREVIEW_FAILURE",
    CONFIRM_REQUEST: "currencyExchange/CONFIRM_REQUEST",
    CONFIRM_SUCCESS: "currencyExchange/CONFIRM_SUCCESS",
    CONFIRM_FAILURE: "currencyExchange/CONFIRM_FAILURE",
    READ_TRANSACTION_REQUEST: "currencyExchange/READ_TRANSACTION_REQUEST",
    READ_TRANSACTION_SUCCESS: "currencyExchange/READ_TRANSACTION_SUCCESS",
    READ_TRANSACTION_FAILURE: "currencyExchange/READ_TRANSACTION_FAILURE",
    CLEAR_TRANSACTION_TICKET: "currencyExchange/CLEAR_TRANSACTION_TICKET",
    DOWNLOAD_DECLARATION_REQUEST: "currencyExchange/DOWNLOAD_DECLARATION_REQUEST",
    FETCHING_DOWNLOAD_START: "currencyExchange/FETCHING_DOWNLOAD_START",
    FETCHING_DOWNLOAD_END: "currencyExchange/FETCHING_DOWNLOAD_END",
    RESET: "currencyExchange/RESET",
};

const INITIAL_STATE = {
    fetchingQuote: false,
    fetchingHistory: false,
    fetchingPreview: false,
    fetchingConfirm: false,
    cotizacionCompra: null,
    cotizacionVenta: null,
    transactions: [],
    totalCount: 0,
    totalPages: 0,
    pageNumber: 1,
    previewData: null,
    confirmData: null,
    transactionTicket: null,
    fetchingTransaction: false,
    fetchingDownload: false,
    error: null,
};

const reducer = (state = INITIAL_STATE, action = {}) => {
    switch (action.type) {
        case types.QUOTE_REQUEST:
            return {
                ...state,
                fetchingQuote: true,
                error: null,
            };
        case types.QUOTE_SUCCESS:
            return {
                ...state,
                fetchingQuote: false,
                cotizacionCompra: action.cotizacionCompra,
                cotizacionVenta: action.cotizacionVenta,
            };
        case types.QUOTE_FAILURE:
            return {
                ...state,
                fetchingQuote: false,
                error: action.error,
            };
        case types.HISTORY_REQUEST:
            return {
                ...state,
                fetchingHistory: true,
                error: null,
            };
        case types.HISTORY_SUCCESS: {
            const isAppend = action.isInfiniteScroll && action.pageNumber > 1;
            const newTransactions = action.transactions || [];
            const transactions = isAppend ? [...(state.transactions || []), ...newTransactions] : newTransactions;
            return {
                ...state,
                fetchingHistory: false,
                transactions,
                totalCount: action.totalCount,
                totalPages: action.totalPages,
                pageNumber: action.pageNumber,
            };
        }
        case types.HISTORY_FAILURE:
            return {
                ...state,
                fetchingHistory: false,
                error: action.error,
            };
        case types.PREVIEW_REQUEST:
            return {
                ...state,
                fetchingPreview: true,
                previewData: null,
                error: null,
            };
        case types.PREVIEW_SUCCESS:
            return {
                ...state,
                fetchingPreview: false,
                previewData: action.previewData,
            };
        case types.PREVIEW_FAILURE:
            return {
                ...state,
                fetchingPreview: false,
                error: action.error,
            };
        case types.CONFIRM_REQUEST:
            return {
                ...state,
                fetchingConfirm: true,
                confirmData: null,
                error: null,
            };
        case types.CONFIRM_SUCCESS:
            return {
                ...state,
                fetchingConfirm: false,
                confirmData: action.confirmData,
            };
        case types.CONFIRM_FAILURE:
            return {
                ...state,
                fetchingConfirm: false,
                error: action.error,
            };
        case types.READ_TRANSACTION_REQUEST:
            return {
                ...state,
                fetchingTransaction: true,
                transactionTicket: null,
            };
        case types.READ_TRANSACTION_SUCCESS:
            return {
                ...state,
                fetchingTransaction: false,
                transactionTicket: action.transactionTicket,
            };
        case types.READ_TRANSACTION_FAILURE:
            return {
                ...state,
                fetchingTransaction: false,
                transactionTicket: null,
            };
        case types.CLEAR_TRANSACTION_TICKET:
            return {
                ...state,
                transactionTicket: null,
                fetchingTransaction: false,
            };
        case types.FETCHING_DOWNLOAD_START:
            return {
                ...state,
                fetchingDownload: true,
            };
        case types.FETCHING_DOWNLOAD_END:
            return {
                ...state,
                fetchingDownload: false,
            };
        case types.RESET:
            return INITIAL_STATE;
        default:
            return state;
    }
};

export default reducer;

export const actions = {
    loadQuote: () => ({
        type: types.QUOTE_REQUEST,
    }),
    loadHistory: (filterType, pageNumber, isInfiniteScroll = false) => ({
        type: types.HISTORY_REQUEST,
        filterType,
        pageNumber,
        isInfiniteScroll,
    }),
    createPreview: (data) => ({
        type: types.PREVIEW_REQUEST,
        data,
    }),
    confirmExchange: (solicitudCambioId, tipoOperacion, declaracionJuradaAceptada, otp) => ({
        type: types.CONFIRM_REQUEST,
        solicitudCambioId,
        tipoOperacion,
        declaracionJuradaAceptada,
        otp,
    }),
    readTransaction: (transactionId) => ({
        type: types.READ_TRANSACTION_REQUEST,
        transactionId,
    }),
    clearTransactionTicket: () => ({
        type: types.CLEAR_TRANSACTION_TICKET,
    }),
    downloadDeclaration: (format, i18nVar) => ({
        type: types.DOWNLOAD_DECLARATION_REQUEST,
        format,
        i18nVar,
    }),
    fetchDownloadStart: () => ({
        type: types.FETCHING_DOWNLOAD_START,
    }),
    fetchDownloadEnd: () => ({
        type: types.FETCHING_DOWNLOAD_END,
    }),
    reset: () => ({
        type: types.RESET,
    }),
};

export const selectors = {
    getFetchingQuote: (state) => state.currencyExchange.fetchingQuote,
    getFetchingHistory: (state) => state.currencyExchange.fetchingHistory,
    getFetchingPreview: (state) => state.currencyExchange.fetchingPreview,
    getFetchingConfirm: (state) => state.currencyExchange.fetchingConfirm,
    getCotizacionCompra: (state) => state.currencyExchange.cotizacionCompra,
    getCotizacionVenta: (state) => state.currencyExchange.cotizacionVenta,
    getTransactions: (state) => state.currencyExchange.transactions,
    getTotalCount: (state) => state.currencyExchange.totalCount,
    getTotalPages: (state) => state.currencyExchange.totalPages,
    getPageNumber: (state) => state.currencyExchange.pageNumber,
    getPreviewData: (state) => state.currencyExchange.previewData,
    getConfirmData: (state) => state.currencyExchange.confirmData,
    getTransactionTicket: (state) => state.currencyExchange.transactionTicket,
    getFetchingTransaction: (state) => state.currencyExchange.fetchingTransaction,
    getFetchingDownload: (state) => state.currencyExchange.fetchingDownload,
    getError: (state) => state.currencyExchange.error,
};
